import React from "react";
import { Link } from "react-router-dom";
import ResearchLayout, { useReveal } from "../ResearchLayout";

export default function DirectorMessage() {
  useReveal();

  return (
    <ResearchLayout>
      {/* Hero */}
      <section
        style={{
          padding: "100px 0 60px",
          background:
            "linear-gradient(135deg, #0d3b6e 0%, #076cec 100%)",
          color: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="rs-blob" style={{ width: 400, height: 400, background: "#04b3bf", top: "-150px", right: "-100px" }} />
        <div className="rs-container rs-text-center" style={{ position: "relative", zIndex: 2 }}>
          <span
            className="rs-section-eyebrow"
            style={{
              background: "rgba(255,255,255,0.15)",
              color: "#fff",
              backdropFilter: "blur(10px)",
            }}
          >
            Leadership
          </span>
          <h1 style={{ fontSize: "clamp(2rem, 5vw, 3.4rem)", fontWeight: 800, margin: "12px 0 0" }}>
            Director's Message
          </h1>
        </div>
      </section>

      {/* Director Card */}
      <section className="rs-section" style={{ paddingTop: 60 }}>
        <div className="rs-container">
          <div
            className="rs-reveal"
            style={{
              display: "grid",
              gridTemplateColumns: "320px 1fr",
              gap: 50,
              alignItems: "start",
            }}
          >
            <div
              style={{
                position: "sticky",
                top: 100,
                textAlign: "center",
              }}
              className="rs-dir-card"
            >
              <div
                style={{
                  width: 220,
                  height: 220,
                  margin: "0 auto 20px",
                  borderRadius: "50%",
                  background: "var(--rs-grad-1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontSize: "5rem",
                  boxShadow: "0 20px 50px rgba(7, 108, 236,0.3)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <i className="fa-regular fa-user-doctor"></i>
                <div
                  style={{
                    position: "absolute",
                    inset: -2,
                    borderRadius: "50%",
                    border: "2px solid var(--rs-secondary)",
                    animation: "rsPulse 3s ease-in-out infinite",
                    pointerEvents: "none",
                  }}
                />
              </div>
              <h3 style={{ fontSize: "1.3rem", fontWeight: 800, color: "var(--rs-dark)", margin: "0 0 4px" }}>
                Director Research &amp; Quality
              </h3>
              <p style={{ fontSize: "0.9rem", color: "var(--rs-secondary)", fontWeight: 600, margin: 0 }}>
                Maroof International Hospital
              </p>

              <div
                style={{
                  marginTop: 24,
                  padding: 18,
                  borderRadius: 14,
                  background: "linear-gradient(135deg, #f0f7ff 0%, #e6fffa 100%)",
                  fontSize: "0.85rem",
                  color: "#475569",
                  lineHeight: 1.6,
                }}
              >
                <i
                  className="fa-regular fa-quote-left"
                  style={{ color: "var(--rs-primary)", fontSize: "1.5rem", marginBottom: 8 }}
                ></i>
                <div style={{ fontStyle: "italic" }}>
                  Together, we can transform healthcare through evidence-based research.
                </div>
              </div>
            </div>

            <div>
              <p
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  color: "var(--rs-dark)",
                  lineHeight: 1.6,
                  marginBottom: 28,
                  padding: "20px 0 20px 24px",
                  borderLeft: "4px solid var(--rs-secondary)",
                }}
              >
                It is my privilege to welcome you to the Clinical Research Department at Maroof International Hospital.
              </p>

              <div style={{ fontSize: "1rem", lineHeight: 1.85, color: "#374151" }}>
                <p>
                  At Maroof, we believe that clinical research is the cornerstone of advancing healthcare,
                  bringing innovative treatments to patients, and strengthening the future of medicine in Pakistan.
                </p>
                <p>
                  Since joining Maroof International Hospital in 2022, I have witnessed the rapid growth of our
                  Clinical Trial Unit into one of the country's most trusted and high-performing research centers.
                  Our greatest strength lies in our people. At Maroof, we have built a dedicated team of
                  GCP-certified professionals — physicians, nurses, coordinators, and support staff — who work
                  with precision and compassion to ensure the highest standards of research ethics and patient
                  safety.
                </p>
                <p>
                  Beyond clinical trials, we continue to expand our capacity in observational studies, clinical
                  audits, and training programs, empowering the next generation of clinical researchers in
                  Pakistan.
                </p>
                <p>
                  By fostering collaborations with esteemed international and local partners, we aim to position
                  Pakistan as a strong contributor to global healthcare research.
                </p>
                <p>
                  I warmly invite you to join us on this journey of discovery, innovation, and service. Together,
                  we can transform healthcare through evidence-based research and create lasting impact for
                  patients, families, and communities.
                </p>
              </div>

              <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginTop: 36 }}>
                <Link to="/research/team" className="rs-btn rs-btn-primary">
                  <i className="fa-regular fa-users"></i>
                  Meet the Team
                </Link>
                <Link to="/research/vision-mission" className="rs-btn rs-btn-outline">
                  Vision &amp; Mission
                </Link>
              </div>
            </div>
          </div>

          <style>{`
            @media (max-width: 900px) {
              .rs-dir-card { position: static !important; }
              .rs-container > .rs-reveal { grid-template-columns: 1fr !important; }
            }
          `}</style>
        </div>
      </section>
    </ResearchLayout>
  );
}
